"use client"

import React, { Component, Suspense } from "react"
import { Analytics } from "@vercel/analytics/next"

class AnalyticsErrorBoundary extends Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    console.warn("[Analytics] Suppressed error:", error.message)
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

export function SafeAnalytics() {
  return (
    <AnalyticsErrorBoundary>
      <Suspense fallback={null}>
        <Analytics />
      </Suspense>
    </AnalyticsErrorBoundary>
  )
}
